import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo1.png';

const _withScopeId = n => (_pushScopeId("data-v-587b15c8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "avatar-dropdown"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "user-avatar",
  src: _imports_0
}, null, -1
/* HOISTED */
));

const _hoisted_3 = {
  class: "user-name"
};
const _hoisted_4 = {
  class: "hidden-xs-only"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 修改密码 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("提交");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vab_icon = _resolveComponent("vab-icon");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_form = _resolveComponent("el-form");

  const _component_el_popover = _resolveComponent("el-popover");

  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  return _openBlock(), _createBlock(_component_el_dropdown, {
    onCommand: $setup.handleCommand,
    onVisibleChange: $setup.handleVisibleChange
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "edit-line"
        }), _createCommentVNode(" <span>{{ translateTitle('修改密码') }}</span> "), _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 400,
          trigger: "click",
          visible: $setup.visible
        }, {
          reference: _withCtx(() => [_createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = $event => $setup.visible = true)
          }, [_hoisted_5, _createCommentVNode(" <vab-icon icon=\"user-line\" /> ")]), _createCommentVNode(" <span>修改密码</span> ")]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            model: $setup.form,
            "label-width": "60px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "新密码"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $setup.form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.form.password = $event),
                placeholder: "请输入密码"
              }, null, 8
              /* PROPS */
              , ["modelValue"])]),
              _: 1
              /* STABLE */

            }), _createVNode(_component_el_form_item, {
              style: {
                "margin-bottom": "0"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "success",
                onClick: $setup.editPass
              }, {
                default: _withCtx(() => [_hoisted_6]),
                _: 1
                /* STABLE */

              }), _createVNode(_component_el_button, {
                type: "info",
                onClick: $setup.close
              }, {
                default: _withCtx(() => [_hoisted_7]),
                _: 1
                /* STABLE */

              })]),
              _: 1
              /* STABLE */

            })]),
            _: 1
            /* STABLE */

          }, 8
          /* PROPS */
          , ["model"])]),
          _: 1
          /* STABLE */

        }, 8
        /* PROPS */
        , ["visible"])]),
        _: 1
        /* STABLE */

      }), _createCommentVNode(" <el-dropdown-item command=\"personalCenter\">\n          <vab-icon icon=\"user-line\" />\n          <span>{{ translateTitle('个人中心') }}</span>\n        </el-dropdown-item> "), $setup.show == true ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
        key: 0,
        command: "logout"
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "logout-circle-r-line"
        }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('退出登录')), 1
        /* TEXT */
        )]),
        _: 1
        /* STABLE */

      })) : _createCommentVNode("v-if", true)]),
      _: 1
      /* STABLE */

    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_hoisted_2, _createCommentVNode(" <el-avatar class=\"user-avatar\" :src=\"avatar\" /> "), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($setup.username), 1
    /* TEXT */
    ), _createVNode(_component_vab_icon, {
      class: _normalizeClass(["vab-dropdown", {
        'vab-dropdown-active': $setup.active
      }]),
      icon: "arrow-down-s-line"
    }, null, 8
    /* PROPS */
    , ["class"])])])]),
    _: 1
    /* STABLE */

  });
}